var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showButton)?_c('img',{staticClass:"demo__hint-button cp",attrs:{"src":"/img/misc/demo-hint.svg","alt":""},on:{"click":_vm.showTour}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }